var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("CabeceraTabla", {
        attrs: { permisoAccion: _vm.accionCrear },
        scopedSlots: _vm._u([
          {
            key: "izquierda",
            fn: function() {
              return [
                _c("BuscadorMantenedorSolicitud", {
                  attrs: { filter: _vm.funcionFiltrar },
                  on: {
                    resultadoBusqueda: _vm.handleFormChange,
                    clear: _vm.reiniciarGrilla
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "derecha",
            fn: function() {
              return [
                _c("CrearButton", {
                  attrs: { permisoAccion: _vm.accionCrear },
                  on: {
                    click: function($event) {
                      return _vm.handleCrearClick()
                    }
                  }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _c(
        "div",
        { staticClass: "gridcard rounded-card" },
        [
          _c("MantenedorGridSinCodigo", {
            attrs: {
              "grid-options": _vm.gridOptions,
              "funcionalidad-id": _vm.funcionalidad
            }
          })
        ],
        1
      ),
      _c("CrearSolicitudModal", {
        attrs: { show: _vm.mostrarModalCrear },
        on: { cerrar: _vm.handleCierreModalCrear }
      }),
      _c("VerSolicitudModal", {
        attrs: {
          show: _vm.mostrarModalVer,
          solicitudSeleccionada: _vm.solicitudSeleccionada
        },
        on: { cerrar: _vm.handleCierreModalVer }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }